<template>
  <div class="search-box m-2">
    <input
      type="text"
      class="form-control search"
      :placeholder="$t('page.event-management.search_placeholder')"
      autocomplete="off"
      v-model="equipSearchValue"
      @keydown="equipSearch"
    />
    <i class="ri-search-line search-icon"></i>
  </div>
  <div
    style="height: calc(100% - 20px)"
    class="overflow-auto tree-scroll-wrap"
    v-if="searchType"
  >
    <equipTree
      :itemSelected="itemSelected"
      :dataList="dataList"
      @getDetailId="getDetailId"
      @getDragCharts="getDragCharts"
      :showMeasurement="isShowMeasurement"
    ></equipTree>
  </div>
  <div v-else class="text-center text-black-50 box-center">无匹配数据</div>
</template>
<script>
import { getInstancesDetail, getInstancesDetailId } from "@/service/index";
import equipTree from "@/components/equipTree.vue";
import { changeState } from "@/utils/filter.js";
import { SOCKET_SVC_HOST } from "@/config/common.js";

import _ from "loadsh";
export default {
  emits: [
    "treeChange",
    "getDragCharts",
    "update:isLoading",
    "handleAlert",
    "eventsInitData",
    "update:isShowDetail",
    "update:page",
    "update:perPage",
    "getWebsocket",
  ],
  props: {
    isShowDetail: Boolean,
    isShowMeasurement:  {
      type: Boolean,
      default: false,
    },
  },
  provide() {
    return {
      getChildren: this.getChildren,
    }
  },
  components: {
    equipTree,
  },
  data() {
    return {
      dataList: [],
      originDataList: [],
      equipSearchValue: "",
      searchType: true,
      equipmentList: [],
      stompClient: "",
      itemSelected: "",
      warnStatusList: ["health", "sub-health", "error", "unknown"],
      subscriptions:[],
      retryCount: 0,
      isLoading: false,
      pageSize: 60,
      page: 1,
      maxPage: 999,
    };
  },
  mounted() {
    /* 从dashboard页面过来，默认获取设备序列号root_sn 搜索刷新数据*/
    if(this.$route.query.root_sn){
      this.equipSearchValue = this.$route.query.root_sn
    }

    if (localStorage.getItem('fromLifecycle')) {
      localStorage.removeItem('fromLifecycle')
      this.initDataWhenFromLifeCycle();
      return;
    }
    this.initData();
    // this.initWebSocket();
    this.$nextTick(() => {
      if (document.querySelector(".tree-scroll-wrap")) {
        const selectWarp = document.querySelector(".tree-scroll-wrap")
        selectWarp.addEventListener("scroll", this.loadMore)
      }
    })
  },
  methods: {
    getChildren(children, parent_id) {
      this.dataList.map((_item)=>{
        if(_item.id == parent_id){
          _item.children = children
        }
      })
    },
    loadMore() {
      var bottom = 50; // 底部距离的高度
      let scrollWarp = document.querySelector(".tree-scroll-wrap")
      let currentScrollTop = scrollWarp.scrollTop
      let currentScrollHeight = scrollWarp.scrollHeight
      let currentClientHeight = scrollWarp.clientHeight
      if (!this.isLoading && currentScrollTop + currentClientHeight + bottom >= currentScrollHeight) {
        this.page++
        if (this.page <= this.maxPage) {
          this.getDetail(this.page);
        }
      }
    },
    initWebSocket() {
      const interval = setInterval(() => {
        if (this.retryCount > 10) {
          clearInterval(interval)
          this.retryCount = 0
          return
        }
        const stompClient = this.$websocket.getters.stompClient()
        if (stompClient != null && stompClient.connected) {
          clearInterval(interval)
          stompClient.subscribe("/topic/stream", msg => {
            if (msg && msg.body) {
              let websocketdata = Array.isArray(JSON.parse(msg.body)) ? JSON.parse(msg.body) : [JSON.parse(msg.body)];
              if (this.$route.path == "/iot/health-monitor") {
                this.$emit("getWebsocket", websocketdata);
              }
              websocketdata.map((item) => {
                this.dataList.map((data) => {
                  this.getDeviceState(data, item);
                });
              });
            }
          })
        } else {
          if (!localStorage.getItem("accessToken")) return
          const _url = SOCKET_SVC_HOST + "/messaging/stomp?access_token=" + localStorage.getItem("accessToken");
          this.$websocket.dispatch('WEBSOCKET_INIT', _url)
        }
        this.retryCount++
      }, 1000)
    },
    initData() {
      this.getDetail(this.page);
    },
    // 当从生命周期进入时，初始化数据
    initDataWhenFromLifeCycle() {
      const instanceDetail = JSON.parse(
        localStorage.getItem("instanceDetail")
      );
      localStorage.removeItem("instanceDetail")
      if (instanceDetail) {
        this.dataList = this.recursionArr([instanceDetail]);
        this.originDataList = this.dataList;
        this.itemSelected = instanceDetail.id;
        sessionStorage.setItem("deviceTreeActive", instanceDetail.id);
        localStorage.setItem("equipmentData", JSON.stringify(this.dataList[0]));
        this.equipSearchValue = instanceDetail.name;
      }
    },
    getDetail(page) {
      // this.dataList = [];
      // this.originDataList = [];

      let params = {
        is_tree_table: true,
        page: page,
        page_size: this.pageSize,
      };
      if (this.equipSearchValue.length > 0) {
        params.keyword = this.equipSearchValue;
      }

      this.isLoading = true
      getInstancesDetail(params)
        .then((res) => {
          if (res.payload.data) {
            let resdata = _.cloneDeep(res.payload.data);
            this.dataList = this.dataList.concat(this.recursionArr(res.payload.data));

            this.originDataList = this.dataList;
            let deviceTreeActive =
              sessionStorage.getItem("deviceTreeActive") || "";
            let localStorageDevice = JSON.parse(
              localStorage.getItem("equipmentData")
            );

            /* 判断是否是选择的子层级设备 */ 
            const defaultItem = resdata[0];
            // let selectedId = deviceTreeActive ?? sessionStorage.getItem("deviceTreeActive") ?? defaultItem.id;
            /* 复制一个默认状态的激活id */
            let selectedId = defaultItem.id 
            //如果有存储的激活id，就重复赋值高亮
            if(deviceTreeActive&&localStorageDevice){
              selectedId = localStorageDevice.id
            }
            let selectedItem = defaultItem

            // let selectedItem = resdata.find(item => (item.id == selectedId || (item.children_ids&&item.children_ids.some(a=> a==selectedId)))) ?? defaultItem;
            for(let i = 0;i<resdata.length;i++){
              let item = resdata[i]
              if(item.id == selectedId){
                selectedItem = item
                break;
              }else if((item.children_ids&&item.children_ids.some(a=> a==selectedId))){
                sessionStorage.setItem("deviceChildTreeActive",selectedId)
                selectedItem = item
                item.num = 1
                this.changeType(item,i)  
                break;
              }
            }

            sessionStorage.setItem("deviceTreeActive", selectedItem.id);
            localStorage.setItem("equipmentData", JSON.stringify(selectedItem));
            this.itemSelected = selectedItem.id;

            let dataInfo = {};
            if (deviceTreeActive) {
              //包含&&,树avtive是测点，反之是设备
              dataInfo = localStorageDevice;
            } else {
              dataInfo = resdata[0];
            }

            if (this.$route.path == "/equipment-management" || this.$route.path == "/iot/event-management") {
              this.getDetailId(resdata[0]);
            }

            if (this.$route.path == "/iot/health-monitor" && !deviceTreeActive) {
              this.$emit("treeChange", {
                obj: dataInfo,
              });
            }

            /* if (
              this.$route.path != "/expert-system" &&
              this.$route.path != "/health-monitor" &&
              this.$route.path != "/event-management" && this.$route.path != "/equipment-management"
            ) {
              this.$emit("treeChange", {
                list: this.equipmentList,
                id: dataInfo.id,
              });
            } */
            if (res.payload.count % this.pageSize != 0) {
              this.maxPage = parseInt(res.payload.count / this.pageSize) + 1
            }
            else {
              this.maxPage = parseInt(res.payload.count / this.pageSize)
            }
          }
          this.isLoading = false
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /* 模拟点击获取子层级 */
    changeType(item,index) {
      if (!item.has_children) {
        return;
      }
      item["iconType"] = !item["iconType"];
      let params = {
        is_tree_table: true,
        parent_id: item.id,
        page_size: 0,
      };

      getInstancesDetail(params)
        .then((res) => {
          if (res.payload.data) {
            let _data = _.cloneDeep(res.payload.data)
            _data.map((_item) => {
              _item.attributes.measurements = this.filterMeasurements(_item)
              _item.num = item.num + 1
              _item.subId = "a" + _item.id
            })
            item.children = _data
            // this._getChildren(_data, item.id);
          }
          item.attributes.measurements = this.filterMeasurements(item)
          this.dataList[index] = item
        })
        .catch((err) => {
          console.log(err);
        });
    }, 
    getDeviceState(data, sockteitem) {
      if (data.id === sockteitem.shadowId) {
        let obj = { health: 0, "sub-health": 0, error: 0, unknown: 0 };
        _.get(data, ["attributes", "measurements"]).map((item) => {
          sockteitem.report.map((s) => {
            if (item["key"] == s.id) {
              item["value"] = s.v;

              item.status = changeState(item["value"], {
                operationThresholdLow: Number(item.operationThresholdLow),
                operationThresholdHigh: Number(item.operationThresholdHigh),
                standardThresholdHigh: Number(item.standardThresholdHigh),
                standardThresholdLow: Number(item.standardThresholdLow),
              });
              obj[item.status] += 1;
            }
          });
        });

        data.status = "unknown"; //给个默认状态
        if(obj["health"] >=1){
          data.status = "health";
        }
        if (obj["sub-health"] >= 1){
          data.status = "sub-health";
        }
        if(obj["error"] >= 1){
          data.status = "error";
        }
        //-1未知 0健康 1异常 2危险
        // if (obj["error"] >= 1) {
        //   data.status = "error";
        // } else if (obj["sub-health"] >= 1) {
        //   data.status = "sub-health";
        // } else if (obj["health"] == _.get(data, ["attributes", "measurements"]).length) {
        //   data.status = "health";
        // } else {
        //   data.status = "unknown";
        // }

      } else if (data.children && data.children.length) {
        data.children.map((child) => {
          this.getDeviceState(child, sockteitem);
        });
      }
    },

    //递归数组
    recursionArr(data) {
      let result = [];
      let num = 0;
      let queue = data;
      while (queue.length > 0) {
        num += 1;
        [...queue].forEach((child, i) => {
          /* 测点列表,筛选出需要展示的测点数据 */
          child.attributes.measurements = this.filterMeasurements(child)

          queue.shift();
          child.index = i;
          child.num = num;
          child.iconType = false;

          // this.equipmentList.push(child);
          child["subId"] = "a" + child.id;
          result = result.concat([child]);
          child.children && queue.push(...child.children);
        });
      }
      return result.filter((item) => {
        return item.num == 1;
      });
    },
    //取出包裹数据
    getArr(data) {
      let result = [];
      let queue = data;
      while (queue.length > 0) {
        [...queue].forEach((child) => {
          queue.shift();
          this.equipmentList.push(child);
          result = result.concat([child]);
          child.children && queue.push(...child.children);
        });
      }
    },

    //数组层深分级
    getDepth(json) {
      var arr = [];
      arr.push(json);
      var depth = 0;
      while (arr.length > 0) {
        var temp = [];
        for (var l = 0; l < arr.length; l++) {
          temp.push(arr[l]);
        }
        arr = [];
        for (var i = 0; i < temp.length; i++) {
          if (temp[i].children) {
            for (var j = 0; j < temp[i].children.length; j++) {
              arr.push(temp[i].children[j]);
            }
          }
        }
        if (arr.length >= 0) {
          depth++;
        }
      }
      return depth;
    },
    //树结构搜索过滤
    filterTree(nodes, query, key) {
      // 过滤关键字
      let predicate = (node) => {
        node["depth"] = this.getDepth(node);
        return key ? node[key].includes(query) : node.name.includes(query);
      };
      if (!(nodes && nodes.length)) {
        return [];
      }
      let newChildren = [];
      for (let node of nodes) {
        if (predicate(node)) {
          newChildren.push(node);
          node.children = this.filterTree(node.children, query);
        } else {
          newChildren.push(...this.filterTree(node.children, query));
        }
      }
      return newChildren.length ? newChildren : [];
    },
    getDragCharts({ obj, data }) {
      this.$emit("getDragCharts", {
        obj: obj,
        data: data,
      });
    },
    getDetailId(obj, aItem) {
      if (aItem) {
        var deviceId = aItem.id;
      } else {
        deviceId = obj.id;
      }
      if (
        this.$route.path == "/iot/health-monitor" ||
        this.$route.path == "/iot/atlas-analysis"
      ) {
        if (obj.attributes) {
          //点击的是设备
          this.$emit("treeChange", {
            obj: obj,
            itemId: null,
            clickType: "1",
          });
        } else {
          //点击的是测量值

          this.$emit("treeChange", {
            obj: aItem,
            itemId: obj.id,
            clickType: "1",
          });
        }
      }

      if (this.$route.path == "/iot/expert-system") {
        if (obj.attributes) {
          //点击的是设备
          this.$emit("treeChange", obj.id);
        } else {
          //点击的是测量值
          this.$emit("treeChange", deviceId, obj);
        }
      }

      if (this.$route.path == "/iot/event-management") {
        this.$emit("update:isShowDetail", false);
        this.$emit("update:page", 1);
        this.$emit("update:perPage", 20);

        if (obj.attributes) {
          //点击的是设备
          this.$emit("treeChange", obj, deviceId, "device");
        } else {
          //点击的是测量值
          this.$emit("treeChange", aItem, deviceId, "measure", obj);
        }
      }

      if (this.$route.path == "/equipment-management") {
        if (obj.children.length) {
          this.equipmentList = [];
          let params = {
            is_tree_table: true,
          };
          getInstancesDetail(params)
            .then((res) => {
              if (res.payload.data) {
                this.getArr([obj]);

                if (this.equipmentList.length == 0) {
                  let list = [];
                  list.push(obj);
                  this.$emit("treeChange", {
                    list,
                    id: obj.id,
                  });
                } else {
                  this.$emit("treeChange", {
                    list: this.equipmentList,
                    id: this.dataList[0].id,
                  });
                }
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          this.$emit("treeChange", {
            list: [obj],
            id: obj.id,
          });
        }
      }
      if (this.$route.path == "/equipment-detail") {
        this.equipmentList = [];
        let params = {
          is_tree_table: true,
        };
        getInstancesDetail(params)
          .then((res) => {
            if (res.payload.data) {
              this.recursionArr(res.payload.data);
              this.$router.push({
                path: "/equipment-detail",
                query: {
                  equip_id: obj.id,
                },
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }

      if (/^(\/model)|(\/asset)/.test(this.$route.path) && obj) {
        let params = {
          id: obj.id,
        };
        this.obj_instence_id = obj.id;
        getInstancesDetailId(params)
          .then((res) => {
            if (res.payload) this.detailInfo = res.payload;
            if (res.payload.tags) this.tags = res.payload.tags;
            if (res.payload.children) {
              this.instances = res.payload.children;
            }
            if (res.payload.attributes) {
              this.attributes = res.payload.attributes.attributes;
              this.measurements = res.payload.attributes.measurements;
            }
            this.detailInfo.stock = this.find(
              this.dataList,
              this.detailInfo.id
            );
            this.detailInfo.stock &&
              this.detailInfo.stock.map((item, index) => {
                if (this.detailInfo.id == item) {
                  this.detailInfo["isIndex"] = index;
                }
              });
            if (this.dataList.length > 0) {
              this.dataList.map((item) => {
                if (item.id == this.detailInfo.id) {
                  this.detailInfo["isParent"] = false;
                }
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    //获取父节点
    find(arr, id) {
      let stock = [];
      let going = true;
      var warker = function (arr, id) {
        arr.forEach((item) => {
          if (!going) return;
          stock.push(item.id);
          if (item.id == id) {
            going = false;
          } else if (item.children) {
            warker(item.children, id);
          } else {
            stock.pop();
          }
        });
        if (going) stock.pop();
      };
      warker(arr, id);
      return stock;
    },
    sortByInt(array, key) {
      return array.sort(function (b, a) {
        var x = a[key];
        var y = b[key];
        return y - x;
      });
    },
    //设备搜索
    equipSearch(e) {
      if (e.keyCode == 13) {
        e.cancelBubble = true;
        e.stopPropagation();
        e.preventDefault();

        this.page = 1
        this.dataList = [];
        this.originDataList = [];
        this.getDetail(this.page);
        // if (
        //   this.filterTree(this.originDataList, this.equipSearchValue).length ==
        //   0
        // ) {
        //   this.searchType = false;
        // } else {
        //   this.searchType = true;
        //   this.dataList = this.recursionArr(
        //     this.filterTree(this.originDataList, this.equipSearchValue)
        //   );
        //   // this.dataList = this.sortByInt(this.dataList, "depth").reverse();
        // }
        // if (this.equipSearchValue.length == 0) {
        //   this.searchType = true;
        //   this.getDetail();
        // }
      }
    },
    /* 过滤掉不展示测点 */
    filterMeasurements(child){
      /* 测点列表,筛选出需要展示的测点数据 */
      let info = _.cloneDeep(child)
      let list = []
      if(info.attributes&&info.attributes.measurements.length){
        list= info.attributes.measurements.filter(item=>item.is_show === undefined || item.is_show )
      }
      return list;
    }

  },
};
</script>
